import { DueDateChangeError } from '../types';
import { VALID_DUE_DATES } from '../../apis';

export const defaultDueDateChangeError: DueDateChangeError = {
    dueDate: { required: 'Due date is required.', value: `Due date should be one of: ${VALID_DUE_DATES.join(', ')}.` },
};
